import {Component, OnDestroy, OnInit} from "@angular/core";
import {UserSwitchService} from "./user-switch.service";
import {AppSettingsService} from "../app-settings/app-settings.service";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: "resume-user",
  template: `<a class="nav-link text-left" href="javascript:void(0);" (click)="resumeUser()" *ngIf="isSwitched">Resume Session</a>`,
  providers: [
    UserSwitchService,
  ],
})
export class ResumeUserComponent implements OnInit, OnDestroy {
  private userSubscription: Subscription;
  isSwitched: boolean = false;

  constructor(
    private userSwitchService: UserSwitchService,
    private appSettingsService: AppSettingsService,
  ) {}

  ngOnInit() {
    this.userSubscription = this.appSettingsService.user.subscribe((user) => {
      this.isSwitched = user.isSwitched;
    });
  }

  ngOnDestroy() {
    if (this.userSubscription && !this.userSubscription.closed) {
      this.userSubscription.unsubscribe();
    }
  }

  public resumeUser(): void {
    this.userSwitchService.resumeUser()
      .catch((error) => { console.log(error); })
      .then(() => { document.location.reload(true); });
  }
}
